import { render, staticRenderFns } from "./teamAdd.vue?vue&type=template&id=23069b69&scoped=true"
import script from "./teamAdd.vue?vue&type=script&lang=js"
export * from "./teamAdd.vue?vue&type=script&lang=js"
import style0 from "./teamAdd.vue?vue&type=style&index=0&id=23069b69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23069b69",
  null
  
)

export default component.exports